import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { VendorInformation } from './vendor-information.model';
import { RestApiWrapperService } from '@shared/services/rest-api-wrapper.service';
import { BaseRestApiService } from '@shared/services/base-rest-api.service';
import { VendorInformationApiConstants } from './vendor-information.constant';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class VendorInformationService extends BaseRestApiService {

  constructor(_restApiWrapperService: RestApiWrapperService) {
    super(_restApiWrapperService);
  }

  // TODO: backend returns no array. What is the difference with detail and this endpoint
  public list(organizationId: string): Observable<VendorInformation> {
    return this.get<VendorInformation>(
            VendorInformationApiConstants.vendorInformation.list(organizationId),
            {params: {page: 0, size: 1000}}
           ).pipe(
             map(organization => new VendorInformation(organization))
           );
  }

  public detail(organizationId: string, informationId: string): Observable<VendorInformation> {
    return this.get<VendorInformation>(
            VendorInformationApiConstants.vendorInformation.detail(organizationId, informationId)
           ).pipe(
             map(organization => new VendorInformation(organization))
           );
  }


  public update(organizationId: string, vendorInformation: VendorInformation): Observable<any> {
    return this.put(
             VendorInformationApiConstants.vendorInformation.update(organizationId, vendorInformation.id),
             JSON.stringify(vendorInformation)
           );
  }
}
